// extracted by mini-css-extract-plugin
export default {"rating":"CQ-z","numberOfStars":"DQ-z","count":"EQ-z","barGraphSpacing":"FQ-z","barGraph":"GQ-z"};